export function getCarouselImages(selectedLocale: string) {
  if (selectedLocale === 'en') {
    return [
      'https://images.ctfassets.net/modxx330knqj/4CCxFznFYN3qitszVs3ExD/37fff6061008215dc369fab3b9a615ca/1_-_Finding-1.png', //Funding explorer
      'https://images.ctfassets.net/modxx330knqj/5bYL7W0e9Ct5ULspqXHoYJ/5c9ba9d13c7f2462ce99f4acc54869cc/1_-_Finding-2.png', //Funding intelligence
      'https://images.ctfassets.net/modxx330knqj/2WuHZw8soPMdZk5Ys79UIN/fbb3a6f69f25bfef3777d4240ed9184a/1_-_Finding__16_.png', //Gin
      'https://images.ctfassets.net/modxx330knqj/6XZkbP8tv04aWEbBGFBs4G/5c9ad63cdd7157726d43d03df6da7aa7/1_-_Finding-4.png', //Alerts
      'https://images.ctfassets.net/modxx330knqj/3FzpO17LnNhqYbn43XsGqz/7eef66cac5d2fc352b74fffbc6be591a/1_-_Charles.png', //Charles
    ];
  }
  return [
    'https://images.ctfassets.net/modxx330knqj/4CCxFznFYN3qitszVs3ExD/9cb24380daa442c8d4146ac257bdecd8/1_-_Finding-1.png', //Funding explorer
    'https://images.ctfassets.net/modxx330knqj/5bYL7W0e9Ct5ULspqXHoYJ/6ac27b44cc5b8a0aa7bcbba21c7020c4/1_-_Finding-2.png', //Funding intelligence
    'https://images.ctfassets.net/modxx330knqj/2WuHZw8soPMdZk5Ys79UIN/4469487b73e69317eac1a9b42bbfacf1/1_-_Finding__15_.png', //Gin
    'https://images.ctfassets.net/modxx330knqj/6XZkbP8tv04aWEbBGFBs4G/17b88e3d79cd166a13390221450ce809/1_-_Finding-4.png', //Alerts
    'https://images.ctfassets.net/modxx330knqj/3FzpO17LnNhqYbn43XsGqz/61977c85da81b196dfeeeb8ca69cb3ad/1_-_Charles__1_.png', //Charles
  ];
}
